import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map, shareReplay } from 'rxjs/operators';

import { UtilsService } from '@jht/brand-services';

import { Insights } from './insights';
import { ContentService } from '../shared/content/content.service';

@Injectable({ providedIn: 'root' })
export class InsightsService {
    cachedData$!: Observable<Insights[]>;
    cachedData!: Insights[];

    constructor(
        private contentService: ContentService,
        private utilsService: UtilsService,
    ) {
        this.setCachedData();
        this.cachedData$.subscribe((data) => (this.cachedData = data));
    }

    getInsightByTitle(slug: string): Observable<Insights | undefined> {
        return this.cachedData$.pipe(
            first(),
            map((items) =>
                items.find(
                    (insight) =>
                        this.utilsService.slugify(insight.slug) === slug,
                ),
            ),
        );
    }

    getInsights(limit: number): Observable<Insights[]> {
        return this.cachedData$.pipe(
            first(),
            map((items) =>
                items
                    .filter((item) => item.featured === 'False')
                    .slice(0, limit),
            ),
        );
    }

    setCachedData() {
        if (!this.cachedData) {
            this.cachedData$ = this.contentService
                .getComponent('insights')
                .pipe(shareReplay({ bufferSize: 1, refCount: false }));
        }
    }
}
